var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPompa2Deaktywowana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 12.04,
    y1: 39.71,
    x2: 16.17,
    y2: 39.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.83,
    y1: 39.71,
    x2: 32.96,
    y2: 39.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 24.61,
    r: 4.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 17.18,
    y1: 5.9,
    x2: 27.82,
    y2: 5.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.55,16.73h.52l.03-.31s.2-.69-.68-1.16c-.61-2.65-1.82-3.46-1.82-3.46l.21-.23v-5.66l.29-.19v-.94s-.81-1.34-5.56-1.34c-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0-4.75,0-5.56,1.34-5.56,1.34v.94l.29.19v5.66l.21.23s-1.21.81-1.82,3.46c-.87.47-.68,1.16-.68,1.16l.03.31h.52l.03,3.25c-.9.35-.69,1.12-.69,1.12v.33h.65l.04,3.26c-.98.51-.67,1.14-.67,1.14l.03.28h.62s-.03,2.17-.06,3.31c-.84.45-.69,1.09-.69,1.09l.11.29h.64s.33,2.13.53,3.44c-.68.28-.59.96-.59.96l.11.25h.69l.59,3.66s-.67-.05-.67.95c.41,1.31,2.38,1.5,2.38,1.5h8s1.98-.2,2.38-1.5c0-.99-.67-.95-.67-.95l.59-3.66h.69l.11-.25s.09-.68-.59-.96c.2-1.31.53-3.44.53-3.44h.64l.11-.29s.15-.65-.69-1.09c-.02-1.14-.06-3.31-.06-3.31h.62l.03-.28s.31-.64-.67-1.14c0-.09,0-.16,0-.25h2.67v-2.7h-2.64c0-.31,0-.32,0-.32h.65v-.33s.21-.77-.69-1.12l.03-3.25Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPompa2Deaktywowana);
export default __webpack_public_path__ + "static/media/ico-pompa2-deaktywowana.cef8447aed1b81e3850c412c81f75062.svg";
export { ForwardRef as ReactComponent };